var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-callout",
    {
      staticClass: "mb-3 callout",
      attrs: {
        "border-color": _vm.getColorStatus(
          _vm.value.proposalServiceStatusId,
          true
        ),
        "has-toggle": false,
        opened: _vm.isOpen
      },
      scopedSlots: _vm._u([
        {
          key: "edition",
          fn: function() {
            return [
              _vm.canChangeStatus
                ? _c("change-proposal-status-row-info", {
                    attrs: { "status-id": _vm.statusToBeChange.id },
                    on: {
                      close: _vm.closeHandler,
                      "on-save-status": _vm.saveStatusHandler
                    }
                  })
                : _c("evaluate-proposal", {
                    attrs: { "proposal-service": _vm.value },
                    on: { close: _vm.closeHandler }
                  })
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("div", { staticClass: "row mt-2 row-container" }, [
        _c("div", { staticClass: "col-md-2 col-12 border-right status" }, [
          _c("div", { staticClass: "row align-items-center" }, [
            _c(
              "div",
              { staticClass: "col-7 col-md-12" },
              [
                _c("custom-balloon", {
                  staticClass: "w-md-90 w-100",
                  attrs: {
                    "background-color": ` bg-${_vm.getColorStatus(
                      _vm.value.proposalServiceStatusId
                    )}`,
                    text: _vm.value.proposalServiceStatus
                  }
                })
              ],
              1
            ),
            _vm.isAdmin
              ? _c("div", { staticClass: "col-12 d-none d-md-block mt-md-4" }, [
                  _c("span", { staticClass: "info" }, [
                    _vm._v(" " + _vm._s(_vm.value.proposalNumber) + " ")
                  ])
                ])
              : _vm._e(),
            _vm.isAdmin
              ? _c("div", { staticClass: "col-12 d-none d-md-block" }, [
                  _c("div", { staticClass: "label" }, [_vm._v("Fecha:")]),
                  _c("span", { staticClass: "info" }, [
                    _vm._v(" " + _vm._s(_vm._f("date")(_vm.value.date)) + " ")
                  ])
                ])
              : _vm._e(),
            _vm.isAdmin
              ? _c("div", { staticClass: "col-12 d-none d-md-block mt-md-4" }, [
                  _c("div", { staticClass: "label" }, [
                    _vm._v("Tipo de Proponente:")
                  ]),
                  _c("span", { staticClass: "info" }, [
                    _vm._v(" " + _vm._s(_vm.value.recruitmentType) + " ")
                  ])
                ])
              : _vm._e()
          ])
        ]),
        _c("div", { staticClass: "col-12 col-md-10" }, [
          _c("div", { staticClass: "row" }, [
            _vm.isAdmin
              ? _c("div", { staticClass: "col-12 d-block d-md-none" }, [
                  _c("div", { staticClass: "label" }, [
                    _vm._v("Número de Propuesta:")
                  ]),
                  _c("span", { staticClass: "info" }, [
                    _vm._v(" " + _vm._s(_vm.value.proposalNumber) + " ")
                  ])
                ])
              : _vm._e(),
            _vm.isAdmin
              ? _c("div", { staticClass: "col-12 d-block d-md-none" }, [
                  _c("div", { staticClass: "label" }, [_vm._v("Fecha:")]),
                  _c("span", { staticClass: "info" }, [
                    _vm._v(" " + _vm._s(_vm._f("date")(_vm.value.date)) + " ")
                  ])
                ])
              : _vm._e(),
            _c("div", { staticClass: "col-12 col-md-4" }, [
              _c("div", { staticClass: "label" }, [_vm._v("Proveedor:")]),
              _c("span", { staticClass: "info" }, [
                _vm._v(" " + _vm._s(_vm.value.provider) + " ")
              ])
            ]),
            _vm.isEvaluator || _vm.isProvider
              ? _c("div", { staticClass: "col-12 col-md-3" }, [
                  _c("div", { staticClass: "label" }, [
                    _vm._v("Número de Propuesta:")
                  ]),
                  _c("span", { staticClass: "info" }, [
                    _vm._v(" " + _vm._s(_vm.value.proposalNumber) + " ")
                  ])
                ])
              : _vm._e(),
            _vm.isEvaluator || _vm.isProvider
              ? _c("div", { staticClass: "col-12 col-md-3" }, [
                  _c("div", { staticClass: "label" }, [_vm._v("Fecha:")]),
                  _c("span", { staticClass: "info" }, [
                    _vm._v(" " + _vm._s(_vm._f("date")(_vm.value.date)) + " ")
                  ])
                ])
              : _vm._e(),
            _vm.isAdmin
              ? _c("div", { staticClass: "col-12 col-md-5" }, [
                  _c("div", { staticClass: "label" }, [
                    _vm._v("Servicios a ofrecer:")
                  ]),
                  _c("span", { staticClass: "info" }, [
                    _vm._v(" " + _vm._s(_vm.value.offeredService) + " ")
                  ])
                ])
              : _vm._e(),
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-md-2 mt-4 mt-md-0 d-none d-md-flex align-items-start",
                class: {
                  "justify-content-end": _vm.isAdmin
                }
              },
              [
                _vm.actionItems.length > 0
                  ? _c("dropdown", {
                      staticClass: "actions-dropdown",
                      attrs: {
                        "data-item": { value: _vm.value, index: _vm.index },
                        items: _vm.actionItems,
                        title: "Acciones"
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm.isAdmin
              ? _c("div", { staticClass: "col-12 mt-4 mb-2" }, [
                  _c("div", { staticClass: "label" }, [
                    _c("em", {
                      staticClass: "fas fa-map-marker-alt color-orange"
                    }),
                    _vm._v(" Áreas: ")
                  ]),
                  _c("span", { staticClass: "info" }, [
                    _vm._v(" " + _vm._s(_vm.value.areas) + " ")
                  ])
                ])
              : _vm._e(),
            _vm.isAdmin
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-11 bg-white border-radius--light mt-4 my-md-0 py-md-2"
                  },
                  [
                    _c("div", { staticClass: "label" }, [
                      _vm._v("Evaluadores:")
                    ]),
                    _c(
                      "div",
                      { staticClass: "info row px-3 mt-1" },
                      _vm._l(_vm.value.evaluations, function(
                        evaluator,
                        evaluatorIndex
                      ) {
                        return _c(
                          "div",
                          {
                            key: `${
                              evaluator.userId
                            }-${evaluatorIndex}-${Math.random()}`,
                            staticClass: "col-12 col-md-6 p-0 evaluator_status"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "evaluator_status__fullname" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("capitalize")(evaluator.fullName)
                                    ) +
                                    " "
                                )
                              ]
                            ),
                            _c("custom-pill", {
                              staticClass: "evaluator_status__pill",
                              attrs: {
                                icon: "fa-xs fas fa-circle",
                                "icon-class": "color-green",
                                text: evaluator.statusName
                              }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "col-12 mt-4 d-block d-md-none" },
              [
                _vm.actionItems.length > 0
                  ? _c("dropdown", {
                      staticClass: "actions-dropdown w-100",
                      attrs: {
                        "data-item": { value: _vm.value, index: _vm.index },
                        items: _vm.actionItems,
                        title: "Acciones"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }